export default "__VITE_ASSET__ZsCnaxHG__"